import axios from "axios";
import { api } from "assets/scripts/utilities/api-clients";
import { FILE_TYPE_MAP } from "src/assets/scripts/utilities/constants";
import { downloadBlob } from "src/assets/scripts/utilities/helpers";

export function useFile(formData) {
  const updateFile = (file) => {
    if (file) {
      formData.value.file_name = file.name;
    } else {
      formData.value.file_name = "";
    }
  };

  const updateFileName = async (fileName) => {
    const file = formData.value.content;

    if (file) {
      formData.value = {
        ...formData.value,
        content: new File([file], fileName, { type: file.type }),
      };
    }
  };

  const file = ref(null);
  const { postFile, postOnboardingFile } = useFileStore();

  const uploadFile = async (entity) => {
    try {
      let payload = {
        file: unref(file),
        file_name: unref(file)?.name,
        file_type: unref(entity)?.type,
        po_id:
          unref(formData)?.po_id?.[0]?._id ||
          unref(formData)?.po_id?._id ||
          unref(formData)?.po_id,
        [FILE_TYPE_MAP[unref(entity).type].key]:
          unref(entity)._id || unref(formData)?._id,
      };

      if (["Proof of Delivery", "Quality Check"].includes(unref(entity).type)) {
        payload.invc_id =
          unref(entity)?.invc_id?._id ||
          unref(entity)?.invc_id ||
          unref(formData).invc_id?._id ||
          unref(formData).invc_id;
      }

      if (unref(entity).type === "Deal Terms") {
        payload.deal_setting_id = unref(entity)?._id;
      }

      const options = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: {
          showMessage: Boolean(entity.showMessage),
        },
      };

      await postFile(payload, options);

      file.value = null;
    } catch (error) {
      console.error("error", error);
    }
  };

  const uploadOnboardingFile = async (entity) => {
    try {
      let payload = {
        file: unref(entity)?.file,
        file_name: unref(entity)?.file_name,
        file_type: unref(entity)?.type,
        file_category: unref(entity)?.category,
        user_id: unref(entity)?.user_id,
        user_document_id: unref(entity)?.user_document_id,
        shop_name: unref(entity)?.shop_name,
        label: unref(entity)?.label,
      };

      const options = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: {
          showMessage: Boolean(entity.showMessage),
          PII: 1,
        },
      };

      const response = await postOnboardingFile(payload, options);

      return response;
    } catch (error) {
      console.error("error", error);
    }
  };

  const getSignedURL = async (file) => {
    try {
      const fileURL = encodeURIComponent(file.file_path ?? file.url);
      const response = await api.get(`/signed/file/?file=${fileURL}`);

      return response?.data?.data;
    } catch (error) {
      console.log(error);
    }
  };

  const downloadFile = async (file) => {
    try {
      const signedFileUrl = await getSignedURL(file);

      const response = await axios.get(signedFileUrl, {
        responseType: "blob",
      });

      downloadBlob(response.data, file.file_name);
    } catch (error) {
      console.error(error);
    }
  };

  const viewFile = async (file) => {
    try {
      const signedFileUrl = await getSignedURL(file);

      window.open(signedFileUrl, "_blank");
    } catch (error) {
      console.error(error);
    }
  };

  const resetFile = () => {
    file.value = null;
  };

  return {
    file,
    updateFile,
    updateFileName,

    downloadFile,
    uploadFile,
    uploadOnboardingFile,
    viewFile,
    resetFile,
  };
}
